import React, { useEffect, useRef, useState } from 'react';
import './styles.scss';
import { Group, Image, Stack, Text } from '@mantine/core';
import { ContentSectionDetail } from '../ContentSection';
import { getSharepointCdnFile } from '../../../utilities';
import NoImage from '../../../assets/icon/illustrations_no-document.svg';
import ModalTestimonyDetail from './ModalTestimonyDetail';
import ButtonBeelajar from '../../elements/Button';
import { useDisclosure } from '@mantine/hooks';
import { useMutation } from '@tanstack/react-query';
import { addPoint } from '../../../services/homepage';
import { highlightText } from '../../../utilities/highlightText';

const TestimonyItem: React.FC<ContentSectionDetail> = ({
  id,
  isSearch,
  name,
  unit,
  title,
  content,
  position,
  courseName,
  isCarousel,
  isPreview,
  imageFilePath,
  shortDescription,
  isHomepage,
  style,
  querysearch,
  videoFilePath
}) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [isHovered, setIsHovered] = useState(false);
  const ref = useRef(null);

  const handleMouseOver = () => setIsHovered(true);
  const handleMouseOut = () => setIsHovered(false);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener('mouseover', handleMouseOver);
      node.addEventListener('mouseout', handleMouseOut);

      return () => {
        node.removeEventListener('mouseover', handleMouseOver);
        node.removeEventListener('mouseout', handleMouseOut);
      };
    }
  }, []);

  const completedMission = useMutation({
    mutationFn: addPoint,
    onSuccess: () => {
      // showNotification({
      //   type: 'success'
      // });
    },
    onError: (error) => {
      // showNotification({
      //   type: 'error',
      //   message: JSON.stringify(error)
      // });
    }
  });

  const handleAddPoint = (data) => {
    let payload = {
      idLearningPage: data,
      from: 'Testimony'
    };
    completedMission.mutate(payload);
  };

  return (
    <>
      <div
        className={
          'container-testimony-item' +
          ` ${isCarousel === 'Y' ? 'carousel' : ''}`
        }
        onClick={() => {
          if (isHomepage) {
            handleAddPoint(id);
          }
          open();
        }}
        style={{
          ...(() => {
            if (isCarousel === 'Y') return { transform: 'none' };
          })(),
          ...style
        }}
        ref={ref}
      >
        <Stack gap={10} justify="space-between" h={'100%'}>
          <div>
            <Text fz={16} fw={700}>
              {querysearch
                ? highlightText(courseName, querysearch)
                : courseName ?? 'Untitled'}
            </Text>

            <Text fz={14} fw={500} mt={10} lineClamp={3}>
              {querysearch
                ? highlightText(courseName, querysearch)
                : shortDescription ?? 'No Description'}
            </Text>
          </div>

          <Group gap={10}>
            <div className="container-testimony-item__image-cover">
              <Image
                src={
                  imageFilePath ? getSharepointCdnFile(imageFilePath) : NoImage
                }
                alt={name}
                className="container-testimony-item__image"
              />
            </div>

            <Stack gap={0} w={isPreview ? 100 : 150}>
              <Text fz={12} fw={700} truncate="end">
                {name}
              </Text>
              <Text fz={12} fw={500} c={'gray'} truncate="end">
                {position || ''}
              </Text>
              <Text fz={12} fw={500} c={'gray'} truncate="end">
                {unit}
              </Text>
            </Stack>
          </Group>
        </Stack>
        {isSearch ? null : (
          <div
            className={`container-testimony-item__wrapper ${
              isHovered ? 'show' : ''
            }`}
          >
            <ButtonBeelajar>Lihat detail</ButtonBeelajar>
          </div>
        )}
      </div>

      <ModalTestimonyDetail
        isVisible={opened}
        content={content}
        shortDescription={shortDescription}
        name={name}
        courseName={courseName}
        unit={unit}
        photo={imageFilePath ? getSharepointCdnFile(imageFilePath) : NoImage}
        position={position}
        title={title}
        video={videoFilePath}
        onClose={() => close()}
      />
    </>
  );
};

export default TestimonyItem;
